import React from 'react';
import * as PropTypes from 'prop-types';
import AutorisationDetentionArmeForm from './AutorisationDetentionArmeForm';

const components = {
    'autorisation-detention-arme': AutorisationDetentionArmeForm,
};

const TitreDetentionForm = ({ type, defaultValues, loading, enregistrer, isMineurNonEmancipe }) => {
    const SpecificForm = components[type];
    return (
        <SpecificForm
            type={type}
            defaultValues={defaultValues}
            loading={loading}
            enregistrer={enregistrer}
            isMineurNonEmancipe={isMineurNonEmancipe}
        />
    );
};

TitreDetentionForm.propTypes = {
    type: PropTypes.string,
    defaultValues: PropTypes.object,
    loading: PropTypes.bool,
    enregistrer: PropTypes.func,
    isMineurNonEmancipe: PropTypes.bool,
};
export default TitreDetentionForm;
